import { DropdownModel } from "./../../report/models/report-filter.model";
import { TranslateService } from "./../../shared/translate/translate.service";
import { AuthService } from "./../../shared/models/auth.service";
import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import {
  UserProfileAddressModel,
  EmailAddressModel,
  UserProfileModel
} from "../../userprofile/models/userprofile.model";
import { UserProfileService } from "../../userprofile/models/userprofile.service";
import { Router, ActivatedRoute } from "@angular/router";
import {
  IKeyValueInterface,
  IAPIResponse,
  ApplicationRouteURL,
  WeGoConfig
} from "../../shared/config";
import { Location } from "@angular/common";
import { FlatPickrModel } from "./../../plugins/flatpickr/flatpickr.model";

@Component({
  selector: "wego-driver-profile",
  template: require('../views/driver-profile.component.html'),
  styles: [
    `
      .input-group.telephone-group .input-group-addon {
        padding: 0px;
        border: 0px;
      }
      .country-select {
        width: 60px;
        border: 1px solid #d2d6de;
        padding: 3px;
        border-bottom-left-radius: 3px;
        border-top-left-radius: 3px;
      }
    `
  ],
  providers: [UserProfileService]
})
export class DriverProfile implements OnInit, OnDestroy {
  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_FORMAT;
  sub: any;
  apiResponse: IAPIResponse;
  submitted = false;
  model: UserProfileModel;
  submitModel: UserProfileModel;
  errorModel: IKeyValueInterface[];
  message: string;
  errorMessage: string;
  urlDefaultPage: string;
  private popupMsg: string;
  private module: string;
  warningMessage: string;
  flatPickrConfigDateOfBirth: FlatPickrModel;
  isDateOfBirth: boolean = false;
  IBANNumberMessage: boolean = false;
  countryList: DropdownModel[];
  isLoading: boolean;
  creditCardModule: string;
  apiErrorMsg: string;

  @ViewChild("changePasswordModal") public changePasswordModal: any;
  @ViewChild("successPopup") public successPopup: any;
  @ViewChild("childModal") public childModal: any;
  @ViewChild("deleteConfirmModal") public deleteConfirmModal: any;

  creditCardHashId: string;
  deleteMessage: string;
  isCreditCard: boolean = false;
  personCountryList: DropdownModel[];

  constructor(
    private personService: UserProfileService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private locationService: Location
  ) { }

  ngOnInit() {
    this.module = this.translate.instant("LblProfile");
    this.creditCardModule = this.translate.instant("LblCreditCardDetails");
    this.flatPickrConfigDateOfBirth = this.SetDefaultFlatPickrConfig();
    this.translate.setDetectedLang();
    this.model = new UserProfileModel();
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.GetTelephoneCountry();
    this.sub = this.activeRoute.params.subscribe(params => {
      this.IBANNumberMessage = params["IBANNumberMessage"];
      if (this.IBANNumberMessage) {
        this.warningMessage = this.translate.instant("LblIBANNumberRequired", [
          this.module
        ]);
      }
    });
    this.GetPersonDetails();
    this.GetPersonCountry()
  }

  public GetPersonDetails() {
    this.personService.GetUserByPersonHashId().subscribe(
      res => {
        this.model = res.data;
        this.isDateOfBirth = this.model.dateOfBirth != "" ? true : false;
        if (this.model.liceanceNumberValidated) {
          this.flatPickrConfigDateOfBirth.clickOpens = false;
        }
        this.GetCreditCardDetails();
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.message = <any>error;
      }
    );
  }

  public GetPersonCountry() {
    this.authService.GetPersonCountry()
      .subscribe(
        res => {
          this.personCountryList = res.data;
        },
        error => {
          this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GetCreditCardDetails() {
    this.personService.GetCreditCardDetailsByPersonHashId().subscribe(
      res => {
        this.model.CreditCardDetails = res.data;
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.message = <any>error;
      }
    );
  }

  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = false;
    flatPickrConfig.time_24hr = false;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.maxDate = new Date(new Date());
    return flatPickrConfig;
  }
  onSubmit(forms: any) {
    this.submitted = true;
    this.UpdatePersonProfile();
  }

  public UpdatePersonProfile() {
    this.personService.UpdateUserProfile(this.model).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant("LblRecordUpdatedSuccess", [
            this.module
          ]);
          this.ShowSuccessPopup();
        } else {
          this.errorModel = res.error;
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public GetTelephoneCountry() {
    this.authService.GetTelephoneCountry().subscribe(
      res => {
        this.countryList = res.data;
      },
      error => {
        this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public ShowChangePasswordModal(personMasterHashId: string) {
    this.changePasswordModal.personHashId = personMasterHashId;
    this.changePasswordModal.show();
  }

  public ChangePasswordModal($event: any) {
    this.message = $event.SuccessMessage;
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
    if (this.isCreditCard == false) {
      this.OnBackClick();
    }
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    if (this.isCreditCard == false) {
      this.OnBackClick();
    } else {
      this.GetCreditCardDetails();
    }
  }

  public OnBackClick() {
    this.locationService.back();
  }

  public ShowDeleteConfirmModal(creditCardHashId: string): void {
    this.isLoading = false;
    this.deleteMessage = this.translate.instant("LblRecordDeleteConfirmation", [
      this.creditCardModule
    ]);
    this.deleteConfirmModal.show();
    this.creditCardHashId = creditCardHashId;
  }

  public HideDeleteConfirmModal() {
    this.deleteConfirmModal.hide();
  }

  public DeleteConfirmSuccessClick(): void {
    this.deleteConfirmModal.hide();
    this.OnDelete();
  }

  public OnDelete() {
    this.isLoading = true;
    this.personService.DeleteCreditCardDetails(this.creditCardHashId).subscribe(
      (res: any) => {
        if (res.data) {
          this.isLoading = false;
          this.popupMsg = this.translate.instant("LblRecordRemovedSuccess", [
            this.creditCardModule
          ]);
          this.isCreditCard = true;
          this.ShowSuccessPopup();
        } else {
          this.isLoading = false;
          this.popupMsg = this.translate.instant("LblInvoiceDeleteValidation");
          this.isLoading = false;
          this.ShowSuccessPopup();
        }
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/driver/components/driver-profile.component.ts